import { render } from "./ShowPanchanga.vue?vue&type=template&id=f29b87d8&scoped=true"
import script from "./ShowPanchanga.vue?vue&type=script&lang=js"
export * from "./ShowPanchanga.vue?vue&type=script&lang=js"

import "./ShowPanchanga.vue?vue&type=style&index=0&id=f29b87d8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f29b87d8"]])

export default __exports__